import { render, staticRenderFns } from "./VistaBlank.vue?vue&type=template&id=0268faa6"
import script from "./VistaBlank.vue?vue&type=script&lang=js"
export * from "./VistaBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports